import { MessageModel } from '@/types/message';

export function addMissingMessage(messages: Array<MessageModel>, newMessage: MessageModel): Array<MessageModel> {
  const messageExists = messages.map((message) => message.id).includes(newMessage.id);

  return !messageExists ? [...messages, newMessage] : messages;
}
